import Vue from "vue";
import axios from "axios";
import store from "../store/store";
import Router from "../router";
axios.defaults.baseURL = `${process.env.VUE_APP_API}/`;

Vue.use({
	install(Vue) {
		let refreshPromise = null; // Promise compartilhada para o refreshToken

		Vue.prototype.$http = {
			buildHeaders(customHeaders = {}) {
				const language = localStorage.getItem("k4-language") ?? "pt-BR";
				axios.defaults.withCredentials = true;
				axios.defaults.headers.common["Accept-Language"] = language;

				Object.keys(customHeaders).forEach((key) => {
					axios.defaults.headers.common[key] = customHeaders[key];
				});
			},
			buildRequestHeaders(config = {}) {
				const headers = {};
				if (config.isIframeContext) {
					headers["X-Integration-Context"] = "iframe";
				}
				return headers;
			},
			getStatus(erro) {
				if (!erro || !erro.response) return -1;
				return erro.response.status;
			},
			refresh(action, config) {
				const clearLocalStorage = () => {
					Vue.prototype.$functions.clearLocalStorage();
					if (
						Router.currentRoute.name !== "Login" &&
						Router.currentRoute.name !== "LoginSupplier" &&
						Router.currentRoute.name !== "inviteOffer" &&
						!Router.currentRoute.meta?.isIframe
					) {
						Router.push({ name: "Login" });
					}
				};

				return new Promise((resolve, reject) => {
					action()
						.then(async (response) => {
							const responseVersion = response.headers["k4-version"];
							const storedVersion = localStorage.getItem("version");

							if (responseVersion === storedVersion) {
								resolve(response);
								return;
							}

							const storageEvent = new StorageEvent("storage", {
								key: "version",
								oldValue: storedVersion,
								newValue: responseVersion,
								url: window.location.href,
								storageArea: localStorage
							});

							clearLocalStorage();
							localStorage.setItem("version", responseVersion);

							if (!Router.currentRoute.meta?.isIframe) {
								window.dispatchEvent(storageEvent);
							}

							resolve(response);
						})
						.catch((requestError) => {
							if (config.ignoreRefresh || this.getStatus(requestError) != 401) {
								reject(requestError);
								return;
							}

							if (
								(Router.currentRoute.name === "inviteOffer" || Router.currentRoute.name === "LoginSupplier") &&
								this.getStatus(requestError) == 401
							) {
								reject(requestError);
								return;
							}

							// Se já existe um refresh em andamento, aguarde ele terminar
							if (refreshPromise) {
								refreshPromise
									.then(() => {
										this.buildHeaders(config.customHeaders);
										action()
											.then((internResponse) => resolve(internResponse))
											.catch((internError) => reject(internError));
									})
									.catch((err) => {
										clearLocalStorage();
										reject(err);
									});
								return;
							}

							// Se não existe, inicia o refresh e salva a promise
							refreshPromise = store._actions.refreshToken[0]()
								.then(() => {
									refreshPromise = null;
									this.buildHeaders(config.customHeaders);
									action()
										.then((internResponse) => resolve(internResponse))
										.catch((internError) => reject(internError));
								})
								.catch((err) => {
									refreshPromise = null;
									clearLocalStorage();
									if (Router.currentRoute.name !== "Login") {
										Router.push({ name: "Login" });
									} else {
										reject(err);
									}
								});
						});
				});
			},
			get(route, data, config = {}) {
				const headers = { "Content-Type": "application/problem+json", ...this.buildRequestHeaders(config) };
				this.buildHeaders(config.customHeaders);
				return this.refresh(() => axios(route, { params: data, headers }), config);
			},
			post(route, data, config = {}) {
				const headers = this.buildRequestHeaders(config);
				this.buildHeaders(config.customHeaders);
				return this.refresh(() => axios.post(route, data, { headers }), config);
			},
			put(route, data, config = {}) {
				const headers = this.buildRequestHeaders(config);
				this.buildHeaders(config.customHeaders);
				return this.refresh(() => axios.put(route, data, { headers }), config);
			},
			delete(route, data, config = {}) {
				const headers = this.buildRequestHeaders(config);
				this.buildHeaders(config.customHeaders);
				return this.refresh(() => axios.delete(route, { data, headers }), config);
			},
			download(route, data, config = {}) {
				const headers = this.buildRequestHeaders(config);
				this.buildHeaders(config.customHeaders);
				return this.refresh(
					() =>
						axios(
							{
								url: route,
								method: "GET",
								responseType: "blob",
								headers
							},
							data
						),
					config
				);
			},
			postDownload(route, data, config = {}) {
				const headers = this.buildRequestHeaders(config);
				this.buildHeaders(config.customHeaders);
				return this.refresh(
					() =>
						axios.post(route, data, {
							responseType: "blob",
							headers
						}),
					config
				);
			},
			getExternal(route, data) {
				return axios(route, {
					params: data,
					headers: { "Content-Type": "application/problem+json" },
					withCredentials: false
				});
			}
		};
	}
});
